import {
  Admission,
  ADMISSION_STATUS_ON_SALE,
  ADMISSION_STATUS_SALES_CLOSED,
  ADMISSION_STATUS_SOLD_OUT,
} from '@domain/admission';
import { Pass } from '@domain/passes';

export const formatSalesStatusToBackend = ({
  offer,
  prevStatus,
  status,
}: {
  offer?: Admission | Pass | null;
  status?: string;
  prevStatus?: string;
}) => {
  const defaultSalesStatus = {
    isSoldOut: offer ? offer.salesStatus.isSoldOut : false,
    isSalesClosed: offer ? offer.salesStatus.isSalesClosed : false,
  };

  if (prevStatus === status) {
    return defaultSalesStatus;
  }

  if (status === ADMISSION_STATUS_SOLD_OUT) {
    return {
      ...defaultSalesStatus,
      isSoldOut: true,
    };
  }

  if (status === ADMISSION_STATUS_SALES_CLOSED) {
    return { ...defaultSalesStatus, isSalesClosed: true };
  }

  if (status === ADMISSION_STATUS_ON_SALE) {
    return { isSoldOut: false, isSalesClosed: false };
  }

  return defaultSalesStatus;
};
